/**
 *
 * Polling loop that will update polling
 * statuses periodically until they are
 * completed. When they are all completed
 * stop the loop.
 *
 */

var _ = require('underscore');

var pollingActionCreators = require('js/lib/actions/PollingInstances/actionCreators');
var pollingActionTypes = require('js/lib/actions/PollingInstances/actionTypes');
var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

var pollingStatusUrl = '/poll/status';
var pollingInterval = 3000;

var elapsed = 0;
var then, now;
var singleModel = sw.data.pageIdentifier === "model-edit-upload-and-buy";

function _doPoll(ModelManager) {

  now = Date.now();

  elapsed = now - then;

  if (elapsed > pollingInterval) {
    ModelManager.amdActivePollingInstances(function (models) {

      var pollingInstanceIds = _.map(models, function (model) {
        return model.id;
      });


      // only continue if we've found models
      if (pollingInstanceIds.length) {

        $.ajax({
          url: pollingStatusUrl,
          data: {
            pollingInstanceIds: pollingInstanceIds,
            singleModel: singleModel
          },
          type: 'post',
          dataType: 'json',
          success: function (data) {
            _.each(data, function (datum) {

              // get only first image
              var imageUrl = '';

              if (datum.images.length) {
                imageUrl = datum.images[0];
              }

              sw.dispatch(pollingActionCreators.pollingStatusUpdated(datum.id, imageUrl, datum.title, datum.status, datum.description, datum.polling, datum.singleModel, datum.modelEditUrl ,datum.model3DToolsUrl));

            });
          },
          complete: function () {
            _doPoll(ModelManager);
          }
        });

      }

    });

    then = now;
  } else {
    window.requestAnimationFrame(function() {
      _doPoll(ModelManager);
    });
  }
}

function _startLoop() {
  require(['js/lib/models/ModelManager'], function(ModelManager) {

    then = now = Date.now();
    _doPoll(ModelManager);

  });
}

// Imperative form
module.exports = function() {
  _startLoop();
};

// Reactive form
sw.on(sw.SW_ACTION_EVENT, function(action) {
  if (action.type === pollingActionTypes.POLLING_STATUS_INITIATED) {
    _startLoop();
  }
});
